import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { TrainingProjectsStore } from '../../stores';

type Props = {
    store: TrainingProjectsStore;
};

const ImportSummarySection: React.FC<Props> = ({ store }) => {
    if (!store.importData) {
        return null;
    }

    return (
        <div className="import-summary-section">
            <h3>Import Summary</h3>
            <p>
                <strong>New Project Name:</strong> {store.importData.importedData.name}
            </p>
            {store.importData.importedData.systemPrompt && (
                <p>
                    <strong>System Prompt:</strong>{' '}
                    {store.importData.importedData.systemPrompt.length > 1000
                        ? `${store.importData.importedData.systemPrompt.substring(0, 1000)}...`
                        : store.importData.importedData.systemPrompt}
                </p>
            )}
            <p>
                <strong>Task Type:</strong> {store.importData.importedData.taskType}
            </p>
            {store.importData.importedData.optimizerType && (
                <p>
                    <strong>Optimizer Type:</strong> {store.importData.importedData.optimizerType}
                </p>
            )}
            {store.importData.importedData.optimizerParams && (
                <p>
                    <strong>Optimizer Parameters:</strong> {store.importData.importedData.optimizerParams}
                </p>
            )}
            {store.importData.importedData.moduleType && (
                <p>
                    <strong>Module Type:</strong> {store.importData.importedData.moduleType}
                </p>
            )}
            {store.importData.importedData.adapterType && (
                <p>
                    <strong>Adapter Type:</strong> {store.importData.importedData.adapterType}
                </p>
            )}
            {store.importData.importedData.jsonSchemas &&
                Object.keys(store.importData.importedData.jsonSchemas).length > 0 && (
                    <p>
                        <strong>JSON Schemas:</strong> {Object.keys(store.importData.importedData.jsonSchemas).length}{' '}
                        schema(s)
                    </p>
                )}
            {store.importData.importedData.fieldDescriptions &&
                Object.keys(store.importData.importedData.fieldDescriptions).length > 0 && (
                    <p>
                        <strong>Field Descriptions:</strong>{' '}
                        {Object.keys(store.importData.importedData.fieldDescriptions).length} field(s)
                    </p>
                )}
            <p>
                <strong>Examples:</strong> {store.importData.importedData.examples?.length || 0}
            </p>
        </div>
    );
};

export default observer(ImportSummarySection);
